import React from 'react';

const VerifyEmailCallback = () => {
    window.open('useat-consumer://verify-email-callback', '_self');
    return null;
};

export default VerifyEmailCallback;